module.exports = __webpack_public_path__ + "img/LATIN10_21.9c1e72e8.jpg";